<template>
  <div class="content c895">
    <h2>Klimatska naprava 1</h2>
  </div>
  <div class="content c590">
    <div class="popup popDev4" style="display:none;">
      <div class="inner">
        <h3>Ali ste prepričani, da želite izbrisati napravo?</h3>
        <div class="msg">
          <h3>Klimatska naprava</h3>
        </div>
        <div class="con">
          <p>Izbrišite napravo, če ste se zmotili pri njenih podatkih oziroma ste izbrali napačno napravo. Če bi želeli, jo lahko kasneje brez težav ponovno dodate.</p>
        </div>
        <div class="btns">
          <a
            href="javascript:void(0)"
            class="btn"
            title="Več"
            onclick="popupDelete(&quot;popDev4&quot;)"
          >NE, PREKLIČI</a>
          <a
            id="ctl00_ContentPlaceHolder1_lnkBtnDeleteDevice"
            class="btn"
            href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$lnkBtnDeleteDevice','')"
          >DA, IZBRIŠI</a>
        </div>
      </div>
    </div>

    <div class="appliance data">
      <div class="icon">
        <span class="AC">Klimatska naprava</span>
      </div>
      <div class="first">
        <h5>TRENUTNA PORABA</h5>
        <span id="ctl00_ContentPlaceHolder1_lblConsumption">
          <span class="et">
            -274.356.238,00 kWh / leto
            <div class="tooltip-bottom">
              Enotna tarifa (ET) je tarifa, ki jo beleži enotarifni števec vsak dan od 0.00 do 24.00 ure. Cena električne energije je ves čas enaka. V primeru, da imate enotarifno merjenje in želite dvotarifnega, pokličite v vaše elektrodistribucijsko podjetje za podrobnejše informacije.
              <br />
              <a
                href="http://www.uresnicujmo.si/o_aplikaciji_za_izracun_prihrankov/predstavitev#tarife"
                target="_blank"
                title="Več"
              >Več o tem &gt;</a>
            </div>
          </span>
        </span>
        <em>
          <span id="ctl00_ContentPlaceHolder1_lblTotalPrice">-20.708.683,20 € / leto</span>
        </em>
      </div>

      <div class="no-data">
        <h5>VAŠI PRIHRANKI</h5>
        <h5>VAŠA NOVA PORABA</h5>
        <div class="message">
          <p>Za izračun nove porabe in prihrankov na izbrani napravi izvedi vsaj en ukrep.</p>
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="toggle-btn" style="display:none;">
        <a href="javascript:void(0)" class="active">Prihranki zaradi izvedenih ukrepov</a>
      </div>
      <ul class="actionsExistingUl"></ul>

      <h3>Zmanjšajte porabo naprave Klimatska naprava</h3>
      <p>Zmanjšajte porabo tako, da izvedete vsaj enega, še bolje pa več, spodaj navedenih ukrepov. Izberite le tiste, ki so v vaših razmerah pomembni.</p>
      <ul>
        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_divAction">
          <a
            class="actionBtnMore active"
            style="cursor:pointer;"
          >Pri hlajenju in ogrevanju ciljano temperaturo znižamo/zvišamo za 1 stopinjo C</a>

          <div style class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl00$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>Prilagajajmo sobno temperaturo: če sobno temperaturo znižamo za samo 1˚C, prihranimo 5 % električne energije.</p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl01_divAction">
          <a class="actionBtnMore" style="cursor:pointer;">Uporabimo sistem ECONAVI</a>

          <div style="display:none;" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl01_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl01$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>S sistemom ECONAVI lahko prihranimo do 30 %.</p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl02_divAction">
          <a
            class="actionBtnMore"
            style="cursor:pointer;"
          >Klimatsko napravo uporabimo v načinu delovanja toplotne črpalke</a>

          <div style="display:none;" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl02_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl02$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>Izbor klimatske naprave v načinu delovanja toplotne črpalke porabi do 64 % manj električne energije kot modeli brez inverterja.</p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl03_divAction">
          <a
            class="actionBtnMore"
            style="cursor:pointer;"
          >Klimatsko napravo uporabimo v načinu delovanja toplotne črpalke s sistemom ECONAVI</a>

          <div style="display:none;" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl03_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl03$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>Izbor klimatske naprave v načinu delovanja toplotne črpalke porabi do 64 % manj električne energije kot modeli brez inverterja, s senzorjem ECONAVI pa omogoča prihranek do 71 %.</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="advice">
      <h4>Imejte vedno v mislih, da lahko prihranite!</h4>
      <p>Na porabo vaše naprave vplivajo različni dejavniki, od energetskega razreda do načina, kako jo uporabljate. Preberite dodatne nasvete, kako znižati porabo električne energije v vašem gospodinjstvu.</p>
      <a
        href="http://www.uresnicujmo.si/nasveti/klima"
        target="_blank"
        alt="več"
        class="more"
      >Preberite si več nasvetov</a>
    </div>
  </div>
  <div class="content r-c">
    <div class="c282">
      <h3>PORABA NAPRAVE KLIMATSKA NAPRAVA 1</h3>
      <div class="select">
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageType"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageType\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageType"
          class="s156"
        >
          <option selected="selected" value="1">Kumulativna poraba (€)</option>
          <option value="2">Kumulativna poraba (kWh)</option>
        </select>
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageTSpan"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageTSpan\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageTSpan"
        >
          <option selected="selected" value="1">za 1 leto</option>
          <option value="5">za 5 let</option>
          <option value="10">za 10 let</option>
          <option value="15">za 15 let</option>
        </select>
      </div>

      <div class="graph">
        <div class="chart">
          <div id="ctl00_ContentPlaceHolder1_divCurrentUsage" class="col without">
            <span id="ctl00_ContentPlaceHolder1_lblCurrentUsage">-20.708.683,20 €</span>
          </div>
          <div id="ctl00_ContentPlaceHolder1_divPotentialUsage" class="col with" style="height:0%;">
            <em id="ctl00_ContentPlaceHolder1_lblChangeUsage" style="top:1px;">
              100%
              <em>Prihranki</em>
            </em>
            <span id="ctl00_ContentPlaceHolder1_lblPotentialUsage">0€</span>
          </div>
        </div>
        <div class="legend">
          <div class="col">
            <strong>Poraba brez</strong> izvedenih ukrepov
          </div>
          <div class="col">
            <strong>Poraba z</strong> izvedenimi ukrepi
          </div>
        </div>
      </div>
    </div>
    <div class="c282">
      <h3>PORABA NAPRAVE KLIMATSKA NAPRAVA 1</h3>
      <div class="select">
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageType2"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageType2\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageType2"
          class="s156"
        >
          <option selected="selected" value="1">Kumulativna poraba (€)</option>
          <option value="2">Kumulativna poraba (kWh)</option>
        </select>
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageTSpan2"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageTSpan2\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageTSpan2"
        >
          <option value="1">za 1 leto</option>
          <option selected="selected" value="5">za 5 let</option>
          <option value="10">za 10 let</option>
          <option value="15">za 15 let</option>
        </select>
      </div>
      <div class="graph image">
        <div class="chart">
          <img
            id="ctl00_ContentPlaceHolder1_Chart1"
            src="/Images/Charts/Chart000010.png?90c5c128-fd39-4583-b659-57bf732974aa"
            alt
            usemap="#ctl00_ContentPlaceHolder1_Chart1ImageMap"
            style="height:168px;width:263px;border-width:0px;padding:0;"
          />
          <map
            name="ctl00_ContentPlaceHolder1_Chart1ImageMap"
            id="ctl00_ContentPlaceHolder1_Chart1ImageMap"
          >
            <area
              shape="poly"
              coords="211, 8, 211, 93, 211, 93, 257, 121, 257, 121, 257, 8, 211, 8"
              title="13.11.2025; -103543416,00239"
              alt
            />
            <area
              shape="poly"
              coords="164, 8, 164, 65, 164, 65, 211, 93, 211, 93, 211, 8, 164, 8"
              title="13.11.2024; -82834732,801912"
              alt
            />
            <area
              shape="poly"
              coords="118, 8, 118, 37, 118, 37, 164, 65, 164, 65, 164, 8, 118, 8"
              title="13.11.2023; -62126049,601434"
              alt
            />
            <area
              shape="poly"
              coords="72, 8, 72, 9, 72, 9, 118, 37, 118, 37, 118, 8, 72, 8"
              title="13.11.2022; -41417366,400956"
              alt
            />
            <area
              shape="poly"
              coords="257, 8, 257, 121, 257, 121, 72, 9, 72, 9, 72, 8, 257, 8"
              title="13.11.2021; -20708683,200478"
              alt
            />
            <area
              shape="poly"
              coords="211, 8, 211, 93, 211, 93, 257, 121, 257, 121, 257, 8, 211, 8"
              title="13.11.2025; -103543416,00239"
              alt
            />
            <area
              shape="poly"
              coords="164, 8, 164, 65, 164, 65, 211, 93, 211, 93, 211, 8, 164, 8"
              title="13.11.2024; -82834732,801912"
              alt
            />
            <area
              shape="poly"
              coords="118, 8, 118, 37, 118, 37, 164, 65, 164, 65, 164, 8, 118, 8"
              title="13.11.2023; -62126049,601434"
              alt
            />
            <area
              shape="poly"
              coords="72, 8, 72, 9, 72, 9, 118, 37, 118, 37, 118, 8, 72, 8"
              title="13.11.2022; -41417366,400956"
              alt
            />
            <area
              shape="poly"
              coords="257, 8, 257, 121, 257, 121, 72, 9, 72, 9, 72, 8, 257, 8"
              title="13.11.2021; -20708683,200478"
              alt
            />
            <area
              shape="poly"
              coords="211, 8, 211, 93, 211, 93, 257, 121, 257, 121, 257, 8, 211, 8"
              title="13.11.2025; -103543416,00239"
              alt
            />
            <area
              shape="poly"
              coords="164, 8, 164, 65, 164, 65, 211, 93, 211, 93, 211, 8, 164, 8"
              title="13.11.2024; -82834732,801912"
              alt
            />
            <area
              shape="poly"
              coords="118, 8, 118, 37, 118, 37, 164, 65, 164, 65, 164, 8, 118, 8"
              title="13.11.2023; -62126049,601434"
              alt
            />
            <area
              shape="poly"
              coords="72, 8, 72, 9, 72, 9, 118, 37, 118, 37, 118, 8, 72, 8"
              title="13.11.2022; -41417366,400956"
              alt
            />
            <area
              shape="poly"
              coords="257, 8, 257, 121, 257, 121, 72, 9, 72, 9, 72, 8, 257, 8"
              title="13.11.2021; -20708683,200478"
              alt
            />
            <area
              shape="poly"
              coords="211, 8, 211, 93, 211, 93, 257, 121, 257, 121, 257, 8, 211, 8"
              title="13.11.2025; -103543416,00239"
              alt
            />
            <area
              shape="poly"
              coords="164, 8, 164, 65, 164, 65, 211, 93, 211, 93, 211, 8, 164, 8"
              title="13.11.2024; -82834732,801912"
              alt
            />
            <area
              shape="poly"
              coords="118, 8, 118, 37, 118, 37, 164, 65, 164, 65, 164, 8, 118, 8"
              title="13.11.2023; -62126049,601434"
              alt
            />
            <area
              shape="poly"
              coords="72, 8, 72, 9, 72, 9, 118, 37, 118, 37, 118, 8, 72, 8"
              title="13.11.2022; -41417366,400956"
              alt
            />
            <area
              shape="poly"
              coords="257, 8, 257, 121, 257, 121, 72, 9, 72, 9, 72, 8, 257, 8"
              title="13.11.2021; -20708683,200478"
              alt
            />
            <area
              shape="poly"
              coords="211, 8, 211, 93, 211, 93, 257, 121, 257, 121, 257, 8, 211, 8"
              title="13.11.2025; -103543416,00239"
              alt
            />
            <area
              shape="poly"
              coords="164, 8, 164, 65, 164, 65, 211, 93, 211, 93, 211, 8, 164, 8"
              title="13.11.2024; -82834732,801912"
              alt
            />
            <area
              shape="poly"
              coords="118, 8, 118, 37, 118, 37, 164, 65, 164, 65, 164, 8, 118, 8"
              title="13.11.2023; -62126049,601434"
              alt
            />
            <area
              shape="poly"
              coords="72, 8, 72, 9, 72, 9, 118, 37, 118, 37, 118, 8, 72, 8"
              title="13.11.2022; -41417366,400956"
              alt
            />
            <area
              shape="poly"
              coords="257, 8, 257, 121, 257, 121, 72, 9, 72, 9, 72, 8, 257, 8"
              title="13.11.2021; -20708683,200478"
              alt
            />
            <area
              shape="poly"
              coords="211, 8, 211, 93, 211, 93, 257, 121, 257, 121, 257, 8, 211, 8"
              title="13.11.2025; -103543416,00239"
              alt
            />
            <area
              shape="poly"
              coords="164, 8, 164, 65, 164, 65, 211, 93, 211, 93, 211, 8, 164, 8"
              title="13.11.2024; -82834732,801912"
              alt
            />
            <area
              shape="poly"
              coords="118, 8, 118, 37, 118, 37, 164, 65, 164, 65, 164, 8, 118, 8"
              title="13.11.2023; -62126049,601434"
              alt
            />
            <area
              shape="poly"
              coords="72, 8, 72, 9, 72, 9, 118, 37, 118, 37, 118, 8, 72, 8"
              title="13.11.2022; -41417366,400956"
              alt
            />
            <area
              shape="poly"
              coords="257, 8, 257, 121, 257, 121, 72, 9, 72, 9, 72, 8, 257, 8"
              title="13.11.2021; -20708683,200478"
              alt
            />
            <area
              shape="poly"
              coords="211, 8, 211, 93, 211, 93, 257, 121, 257, 121, 257, 8, 211, 8"
              title="13.11.2025; -103543416,00239"
              alt
            />
            <area
              shape="poly"
              coords="164, 8, 164, 65, 164, 65, 211, 93, 211, 93, 211, 8, 164, 8"
              title="13.11.2024; -82834732,801912"
              alt
            />
            <area
              shape="poly"
              coords="118, 8, 118, 37, 118, 37, 164, 65, 164, 65, 164, 8, 118, 8"
              title="13.11.2023; -62126049,601434"
              alt
            />
            <area
              shape="poly"
              coords="72, 8, 72, 9, 72, 9, 118, 37, 118, 37, 118, 8, 72, 8"
              title="13.11.2022; -41417366,400956"
              alt
            />
            <area
              shape="poly"
              coords="257, 8, 257, 121, 257, 121, 72, 9, 72, 9, 72, 8, 257, 8"
              title="13.11.2021; -20708683,200478"
              alt
            />
            <area
              shape="poly"
              coords="211, 8, 211, 93, 211, 93, 257, 121, 257, 121, 257, 8, 211, 8"
              title="13.11.2025; -103543416,00239"
              alt
            />
            <area
              shape="poly"
              coords="164, 8, 164, 65, 164, 65, 211, 93, 211, 93, 211, 8, 164, 8"
              title="13.11.2024; -82834732,801912"
              alt
            />
            <area
              shape="poly"
              coords="118, 8, 118, 37, 118, 37, 164, 65, 164, 65, 164, 8, 118, 8"
              title="13.11.2023; -62126049,601434"
              alt
            />
            <area
              shape="poly"
              coords="72, 8, 72, 9, 72, 9, 118, 37, 118, 37, 118, 8, 72, 8"
              title="13.11.2022; -41417366,400956"
              alt
            />
            <area
              shape="poly"
              coords="257, 8, 257, 121, 257, 121, 72, 9, 72, 9, 72, 8, 257, 8"
              title="13.11.2021; -20708683,200478"
              alt
            />
            <area
              shape="poly"
              coords="211, 8, 211, 93, 211, 93, 257, 121, 257, 121, 257, 8, 211, 8"
              title="13.11.2025; -103543416,00239"
              alt
            />
            <area
              shape="poly"
              coords="164, 8, 164, 65, 164, 65, 211, 93, 211, 93, 211, 8, 164, 8"
              title="13.11.2024; -82834732,801912"
              alt
            />
            <area
              shape="poly"
              coords="118, 8, 118, 37, 118, 37, 164, 65, 164, 65, 164, 8, 118, 8"
              title="13.11.2023; -62126049,601434"
              alt
            />
            <area
              shape="poly"
              coords="72, 8, 72, 9, 72, 9, 118, 37, 118, 37, 118, 8, 72, 8"
              title="13.11.2022; -41417366,400956"
              alt
            />
          </map>
        </div>
        <div class="legend">
          <ul>
            <li class="without">Poraba brez izvedenih ukrepov</li>
            <li class="with">Poraba z izvedenimi ukrepi</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>